import {Pipe, PipeTransform} from '@angular/core';
import {AppointmentTypeEnum} from '../../models/appointment';

@Pipe({
  name: 'getTypeAppointment'
})
export class GetTypeAppointmentPipe implements PipeTransform {

  transform(value: AppointmentTypeEnum): unknown {
    if (value === AppointmentTypeEnum.ON_SITE) {
      return 'Presencial';
    } else if (value === AppointmentTypeEnum.CONFERENCE) {
      return 'Videoconferencia grupal';
    } else if (value === AppointmentTypeEnum.ONE_TO_ONE) {
      return 'Videoconferencia';
    }
  }

}
